import React, { useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { Card } from 'reactstrap';
import {
  reportManagersTab,
  reportCampaignsTab,
  reportSequencesTab,
  reportTemplatesTab,
  reportManagersTabPath,
  reportOpportunitiesTabPath,
  reportAccountsTabPath,
  reportCampaignsTabPath,
  reportSequencesTabPath,
  reportTemplatesTabPath,
} from 'constants/routing';
import Tabs from 'components/Tabs';
import { Can, AbilityContext } from 'utils/permissions';
import NavLinkWrapper from 'components/Tabs/NavLinkWrapper';
import ManagersTab from './ManagersTab';
import AccountsTab from './AccountsTab';
import CampaignsTab from './CampaignsTab';
import SequencesTab from './SequencesTab';
import TemplatesTab from './TemplatesTab';
import OpportunitiesTab from './OpportunitiesTab';


const ListStats = ({ match, location }) => {
  const ability = useContext(AbilityContext);
  const ref = useRef();
  const canSeeManagerTab = ability.can('see', 'Manager');
  const canSeeAccountTab = ability.can('see', 'Account');
  const canSeeOpportunitiesTab = ability.can('see', 'Opportunity');

  const reportPath = reportOpportunitiesTabPath(match.url, true);
  const opportunitiesTabPath = reportOpportunitiesTabPath(match.url);

  const scrollTabsIntoView = () => {
    ref.current.scrollIntoView({
      inline: 'end',
    });
  };

  useEffect(() => {
    if (location.pathname !== '/reports') scrollTabsIntoView();
  }, [location.pathname]);

  const isOpportunitiesTabActive = () => [
    opportunitiesTabPath, reportPath,
  ].includes(location.pathname);

  return (
    <Card>
      <div ref={ref} />
      <Tabs>
        <Can I="see" a="Opportunity">
          <NavLinkWrapper
            exact
            to={opportunitiesTabPath}
            className="nav-link"
            isActive={isOpportunitiesTabActive}
            onClick={scrollTabsIntoView}
          >
            Opportunities
          </NavLinkWrapper>
        </Can>
        <Can I="see" a="Account">
          <NavLinkWrapper
            exact
            to={reportAccountsTabPath(match.url, (!canSeeOpportunitiesTab))}
            className="nav-link"
          >
            Accounts
          </NavLinkWrapper>
        </Can>
        <Can I="see" a="Manager">
          <NavLinkWrapper
            exact
            to={reportManagersTab(match.url)}
            className="nav-link"
          >
            Managers
          </NavLinkWrapper>
        </Can>
        <NavLinkWrapper
          exact
          to={reportCampaignsTab(match.url, (!canSeeManagerTab && !canSeeAccountTab))}
          className="nav-link"
        >
          Campaigns
        </NavLinkWrapper>
        <NavLinkWrapper
          exact
          to={reportSequencesTab(match.url)}
          className="nav-link"
        >
          Sequences
        </NavLinkWrapper>
        <NavLinkWrapper
          to={reportTemplatesTab(match.url)}
          className="nav-link"
        >
          Steps & A/B Testing
        </NavLinkWrapper>
      </Tabs>
      <Switch>
        {canSeeOpportunitiesTab &&
          <Route
            path={[reportPath, opportunitiesTabPath]}
            exact
            render={() => (
              <OpportunitiesTab />
            )}
          />
        }
        {canSeeAccountTab &&
          <Route
            path={reportAccountsTabPath(match.path)}
            exact
            render={() => (
              <AccountsTab />
            )}
          />
        }
        {canSeeManagerTab &&
          <Route
            path={reportManagersTabPath(match.path)}
            exact
            render={() => (
              <ManagersTab />
            )}
          />
        }
        <Route
          path={reportCampaignsTabPath(match.path, (!canSeeManagerTab && !canSeeAccountTab))}
          exact
          render={() => (
            <CampaignsTab />
          )}
        />
        <Route
          path={reportSequencesTabPath(match.path)}
          render={() => (
            <SequencesTab />
          )}
        />
        <Route
          path={reportTemplatesTabPath(match.path)}
          render={() => (
            <TemplatesTab />
          )}
        />
      </Switch>
    </Card>
  );
};

ListStats.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default ListStats;
